import { formatDistanceToNow } from 'date-fns';

export function formatDate(dateStr: string | null | undefined): string {
  if (!dateStr) return '—';
  try {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return '—';
    const diffDays = (Date.now() - date.getTime()) / (1000 * 60 * 60 * 24);
    if (diffDays < 7 && diffDays >= 0) {
      return formatDistanceToNow(date, { addSuffix: true });
    }
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }).format(date);
  } catch {
    return '—';
  }
}

export function formatDateRange(
  start: string | null | undefined,
  end: string | null | undefined
): string {
  const fmt = (d: string) => {
    try {
      const date = new Date(d);
      return isNaN(date.getTime())
        ? d
        : new Intl.DateTimeFormat(undefined, { year: 'numeric', month: 'short' }).format(date);
    } catch {
      return d;
    }
  };
  return `${start ? fmt(start) : '?'} — ${end ? fmt(end) : 'Ongoing'}`;
}
